import getContentDataSource from '@gameday/core/datasources/helpers/getContentDatasource';

const atBatDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();

        const {
            config: {
                env,
                locale = 'en-US',
                useContentApi = false,
                context: {
                    gameContext = 'mlb'
                } = {},
                enableSummaryFiltersLive,
                enableSummaryFiltersFinal
            },
            views: {
                game_view
            },
            gumbo: {
                gamePk,
                gameData: {
                    game: { season },
                    status: {
                        abstractGameState
                    } = {}
                }
            } = {}
        } = state;
        const currentView = game_view || abstractGameState.toLowerCase() || 'live';
        const enableSummaryFilters = (currentView === 'live') ? enableSummaryFiltersLive : enableSummaryFiltersFinal;

        const {
            all,
            highlights,
            keyMoments,
            scoringPlays,
            homeRuns,
            strikeouts,
            hardHits,
            highLeverage,
            leadChange,
            winProb
        } = enableSummaryFilters || {};

        const {
            name: contentDataSource,
            params: contentParams
        } = getContentDataSource(useContentApi, { gamePk, locale, gameContext, env });
        return Promise.allSettled([
            componentDataEngine.fetch('playMetrics', {
                gamePk,
                season,
                all,
                highlights,
                keyMoments,
                scoringPlays,
                homeRuns,
                strikeouts,
                hardHits,
                highLeverage,
                leadChange,
                winProb
            }),
            componentDataEngine.fetch(contentDataSource, contentParams)
        ]).then(([playMetricsRes, contentRes]) => {
            componentDataEngine.store(playMetricsRes.value);
            componentDataEngine.store(contentRes.value);
        });
    };
};

export default atBatDataRequestAction;
